'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ACTION_TYPES = exports.MODULE_NAME = exports.selectIsMobile = exports.selectViewportScreenSizeAndOrientation = exports.selectViewportScreenSizeSelector = exports.changeViewport = exports.actions = undefined;

var _actions = require('./actions');

Object.defineProperty(exports, 'actions', {
    enumerable: true,
    get: function get() {
        return _actions.actions;
    }
});
Object.defineProperty(exports, 'changeViewport', {
    enumerable: true,
    get: function get() {
        return _actions.changeViewport;
    }
});

var _selectors = require('./selectors');

Object.defineProperty(exports, 'selectViewportScreenSizeSelector', {
    enumerable: true,
    get: function get() {
        return _selectors.selectViewportScreenSizeSelector;
    }
});
Object.defineProperty(exports, 'selectViewportScreenSizeAndOrientation', {
    enumerable: true,
    get: function get() {
        return _selectors.selectViewportScreenSizeAndOrientation;
    }
});
Object.defineProperty(exports, 'selectIsMobile', {
    enumerable: true,
    get: function get() {
        return _selectors.selectIsMobile;
    }
});

var _constants = require('./constants');

var _reducer = require('./reducer');

var _reducer2 = _interopRequireDefault(_reducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.MODULE_NAME = _constants.MODULE_NAME;
exports.ACTION_TYPES = _constants.ACTION_TYPES;
exports.default = _defineProperty({}, _constants.MODULE_NAME, { reducer: _reducer2.default });